import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, Requisition, RequisitionQueryParams } from "@/types";

export function useGetRequisitions({
  jobId,
  queryOptions,
}: {
  jobId?: string;
  queryOptions: RequisitionQueryParams;
}) {
  return useQuery({
    queryKey: ["requisitions", jobId, queryOptions],
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams(queryOptions);

      // enabled check ensures that the query is not executed if jobId is not provided
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `jobs/${jobId}/requisitions?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        Requisition[],
        HttpResponse<Requisition[]>
      >(path);
      return res.data;
    },
    enabled: !!jobId,
    // Keep previous data while fetching new results so the page doesn't glitch.
    placeholderData: (previousData) => previousData,
  });
}
